
import { useState } from 'react';

interface AdminLoginProps {
  onLogin: () => void;
}

export default function AdminLogin({ onLogin }: AdminLoginProps) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [shake, setShake] = useState(false);

  const ADMIN_PASSWORD = 'adam2025';

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (password === ADMIN_PASSWORD) {
      sessionStorage.setItem('admin_auth', '1');
      onLogin();
    } else {
      setError('密碼錯誤，請再試一次');
      setShake(true);
      setTimeout(() => setShake(false), 500);
    }
  };

  return (
    <div className="min-h-screen bg-black flex items-center justify-center px-4">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[400px] bg-amber-500/5 blur-3xl rounded-full pointer-events-none" />

      <div
        className={`relative w-full max-w-sm transition-all duration-300 ${shake ? 'animate-[shake_0.4s_ease]' : ''}`}
        style={{
          animation: shake ? 'shake 0.4s ease' : undefined,
        }}
      >
        {/* Top line */}
        <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-amber-500/60 to-transparent" />

        <div className="bg-white/[0.03] border border-amber-500/15 rounded-sm p-10">
          {/* Icon */}
          <div className="flex justify-center mb-8">
            <div className="w-14 h-14 flex items-center justify-center rounded-sm bg-amber-500/10 border border-amber-500/20">
              <i className="ri-lock-2-line text-2xl text-amber-400" />
            </div>
          </div>

          <h1
            className="text-center text-xl font-bold text-white/90 mb-1 tracking-widest"
            style={{ fontFamily: "'Noto Serif TC', serif" }}
          >
            後台管理
          </h1>
          <p
            className="text-center text-white/30 text-xs tracking-[0.3em] mb-8"
            style={{ fontFamily: "'Noto Sans TC', sans-serif" }}
          >
            ADMIN PANEL
          </p>

          <form onSubmit={handleSubmit} className="space-y-5">
            <div className="relative">
              <i className="ri-key-2-line absolute left-4 top-1/2 -translate-y-1/2 text-amber-500/40 text-sm" />
              <input
                type="password"
                placeholder="請輸入管理密碼"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  setError('');
                }}
                className="w-full pl-11 pr-5 py-3 bg-white/[0.04] border border-amber-500/15 rounded-sm text-white/80 placeholder-white/20 focus:outline-none focus:border-amber-400/50 transition-all duration-300 text-sm tracking-widest"
                style={{ fontFamily: "'Noto Sans TC', sans-serif" }}
                autoFocus
              />
            </div>

            {error && (
              <div className="flex items-center gap-2 text-red-400/80 text-xs" style={{ fontFamily: "'Noto Sans TC', sans-serif" }}>
                <i className="ri-error-warning-line" />
                <span>{error}</span>
              </div>
            )}

            <button
              type="submit"
              className="w-full py-3 bg-gradient-to-r from-amber-500 to-yellow-400 rounded-sm text-black text-sm font-bold tracking-widest hover:shadow-lg hover:shadow-amber-500/40 transition-all duration-300 hover:scale-[1.02] whitespace-nowrap cursor-pointer"
              style={{ fontFamily: "'Noto Sans TC', sans-serif" }}
            >
              進入後台
            </button>
          </form>
        </div>

        {/* Bottom line */}
        <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-amber-500/30 to-transparent" />
      </div>

      <style>{`
        @keyframes shake {
          0%, 100% { transform: translateX(0); }
          20% { transform: translateX(-8px); }
          40% { transform: translateX(8px); }
          60% { transform: translateX(-6px); }
          80% { transform: translateX(6px); }
        }
      `}</style>
    </div>
  );
}
